import React, { useMemo } from 'react';

import { useEditionAwareness } from '../../../services/edition-awareness-context';
import { getHamsKey } from '../../../services/product-to-hams-key';
import { ModalEntryPoint } from '../shared/modal-entry-point';
import { DIALOG_CONFIG } from './dialog-config';
import { entryPoint } from './standardToPremiumIncentiveOfferModal.entrypoint';

export function StandardToPremiumIncentiveOfferModal(): React.JSX.Element | null {
	const { cloudId, product } = useEditionAwareness();
	const entryPointParams = useMemo(
		() => ({ cloudId, hamsProductKey: getHamsKey(product) }),
		[cloudId, product],
	);
	const modalProps = useMemo(() => ({ width: 968 }), []);

	return (
		<ModalEntryPoint
			entryPoint={entryPoint}
			entryPointParams={entryPointParams}
			modalProps={modalProps}
			dialogConfig={DIALOG_CONFIG}
		/>
	);
}
